import React, { useMemo } from 'react';
import KickImage from 'Reuseables/KickImage';
import Card, { TCategoryCardProps } from '../../Atoms/Card';
import CategoryItemScroll from '../../Molecules/CategoryItemScroll';
import Styles from './CategorySection.module.scss';

type TCategorySectionProps = {
  className?: string;
  items: TCategoryCardProps[];
  slug: string;
  category: string;
};

const CategorySection: React.FC<TCategorySectionProps> = ({
  className,
  items,
  slug,
  category,
}) => {
  const wrapperClassName = useMemo(() => {
    return className ? className : Styles['wrapper'];
  }, [className]);

  const renderItems = useMemo(() => {
    const onCategoryClicked = (category: string) => {
      if (category.toLowerCase() === 'sneakers') {
        window.open(`/sneakers`, '_blank');
        return;
      }
      if (category.toLowerCase() === 'apparel') {
        window.open(`/apparel`, '_blank');
        return;
      }
      if (category.toLowerCase() === 'luxury') {
        window.open(`/luxury`, '_blank');
        return;
      }
    };

    if (!items.length) {
      return null;
    }

    return items.map((item, index) => {
      return (
        <Card.Category
          key={`category-card-${index}`}
          title={item.title}
          description={item.description}
          onClick={() => {
            if (index === 3) {
              window.open(`/${category}/collection/${slug}`, '_blank');
              return;
            }
            onCategoryClicked(item.title);
          }}
        >
          <CategoryItemScroll
            category={item.title}
            slug={index === 3 ? slug : undefined}
            collectionCategory={category}
          />
        </Card.Category>
      );
    });
  }, [items]);

  return (
    <>
      <div className={wrapperClassName}>{renderItems}</div>
    </>
  );
};

export default CategorySection;
